var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.875,
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0127 14.2778C32.777 13.4736 31.886 12.1863 31.6075 10.6864C31.5477 10.3625 31.5143 10.0287 31.5143 9.6875H27.5715L27.5652 25.4659C27.499 27.2329 26.0425 28.6511 24.2575 28.6511C23.7023 28.6511 23.18 28.5127 22.7198 28.2709C21.6648 27.7165 20.9428 26.6125 20.9428 25.3418C20.9428 23.5169 22.4299 22.032 24.2569 22.032C24.598 22.032 24.9253 22.0883 25.2348 22.1848V18.1655C24.9144 18.1218 24.5888 18.0948 24.2569 18.0948C20.2554 18.0948 17 21.3455 17 25.3418C17 27.7935 18.2265 29.9631 20.0983 31.2751C21.277 32.1017 22.7112 32.5883 24.2575 32.5883C28.259 32.5883 31.5143 29.3376 31.5143 25.3418V17.3406C33.0606 18.4487 34.9555 19.1018 37 19.1018V15.1647C35.899 15.1647 34.8733 14.8378 34.0127 14.2778Z",
    fill: "#068BDC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.ca060e2a4e82ddeac24d99350f7e3d41.svg";
export { ForwardRef as ReactComponent };